import React from 'react'
import TrafficManagementHero from './TrafficManagementHero'
import CallToAction from '../../../../LandingSection/CallToAction'
import Footer from '../../../../Components/Footer'
import Header from '../../../../Components/Header'
import Challenge from './Challenge'
import OurSolution from './OurSolution'
import TrafficManagementTechSolutions from './TrafficManagementTechSolutions'

const TrafficManagementPage = () => {
  return (
    <>
      <Header bgColor="#242424"/>
      <div className="overflow-x-hidden w-full">
      <TrafficManagementHero />
      <TrafficManagementTechSolutions />
      <Challenge />
      <OurSolution />
      <CallToAction/>
              <Footer/>
      </div>
    </>
  )
}

export default TrafficManagementPage
